enum CASPartner {
    DEALERTRACK = 'dealertrack',
    ROUTE_ONE = 'routeone',
}

export default CASPartner
